import * as actionTypes from '../actions/actionTypes';
import * as constants from '../constants';
import { updateObject } from '../utility';

const initialState = {
    errorValidateOTP: '',
};

const validateOTPReducer = (state = initialState, action) => {
    switch (action.type.type) {
        case actionTypes.VALIDATE_OTP_SUCCESS:
            return updateObject(state, {
                errorValidateOTP: action.type.response ? '' : constants.INCORRECT_OTP,
            });
        case actionTypes.VALIDATE_OTP_FAILED:
            return updateObject(state, {
                errorValidateOTP: action.type.error.msg,
            });
        default: {
            return state;
        }
    }
};

export default validateOTPReducer;
